import { HTTP } from '@/http';

export default class WidgetService {

  getBalanceWidget(login) {
    return HTTP.get(`widgets/balance/` + login);
  }
}





// WEBPACK FOOTER //
// ./src/services/WidgetService.js